import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesSuspender.vue?vue&type=template&id=0074ab27&scoped=true"
import script from "./LicitacaoAtualizacaoAcoesSuspender.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesSuspender.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoAtualizacaoAcoesSuspender.vue?vue&type=style&index=0&id=0074ab27&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074ab27",
  null
  
)

export default component.exports